import React, { useEffect, useState } from "react";
import { Modal, FormActions } from "../../shared";
import { Icons } from "../../shared/Icons";

export interface BudgetPdfPriceOptions {
  showServicePrices: boolean;
  showSubServicePrices: boolean;
}

interface DownloadBudgetPdfModalProps {
  isOpen: boolean;
  budgetLabel: string;
  loading?: boolean;
  onClose: () => void;
  onConfirm: (options: BudgetPdfPriceOptions) => void;
}

export const DownloadBudgetPdfModal: React.FC<DownloadBudgetPdfModalProps> = ({
  isOpen,
  budgetLabel,
  loading = false,
  onClose,
  onConfirm,
}) => {
  const [showServicePrices, setShowServicePrices] = useState(true);
  const [showSubServicePrices, setShowSubServicePrices] = useState(true);

  useEffect(() => {
    if (isOpen) {
      setShowServicePrices(true);
      setShowSubServicePrices(true);
    }
  }, [isOpen]);

  const handleConfirm = () => {
    onConfirm({
      showServicePrices,
      showSubServicePrices,
    });
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Baixar PDF"
      icon={<Icons.Receipt sx={{ fontSize: 24 }} />}
      size="sm"
      headerGradient="blue"
    >
      <div className="space-y-5">
        <p className="text-sm text-gray-600 dark:text-slate-300">
          Escolha o que exibir no PDF de {budgetLabel}.
        </p>

        <div className="space-y-3">
          <label className="flex items-start gap-3 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={showServicePrices}
              onChange={(e) => setShowServicePrices(e.target.checked)}
              disabled={loading}
              className="mt-1 h-4 w-4 rounded border-gray-300 dark:border-slate-500 bg-white dark:bg-slate-900 text-sky-600 focus:ring-sky-500 dark:focus:ring-sky-400"
            />
            <span>
              <span className="block text-sm font-medium text-gray-900 dark:text-white">
                Exibir preço dos serviços
              </span>
              <span className="block text-xs text-gray-500 dark:text-slate-400 mt-0.5">
                Mostra o valor de cada serviço no PDF
              </span>
            </span>
          </label>

          <label className="flex items-start gap-3 cursor-pointer select-none">
            <input
              type="checkbox"
              checked={showSubServicePrices}
              onChange={(e) => setShowSubServicePrices(e.target.checked)}
              disabled={loading}
              className="mt-1 h-4 w-4 rounded border-gray-300 dark:border-slate-500 bg-white dark:bg-slate-900 text-sky-600 focus:ring-sky-500 dark:focus:ring-sky-400"
            />
            <span>
              <span className="block text-sm font-medium text-gray-900 dark:text-white">
                Exibir preço dos subserviços
              </span>
              <span className="block text-xs text-gray-500 dark:text-slate-400 mt-0.5">
                Mostra o valor de cada subserviço no PDF
              </span>
            </span>
          </label>
        </div>

        <FormActions
          onCancel={onClose}
          onSubmit={handleConfirm}
          loading={loading}
          submitType="button"
          submitText="Baixar PDF"
          cancelText="Cancelar"
        />
      </div>
    </Modal>
  );
};
